import React, {useEffect, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {useTranslate} from "../../system/useTranslate";
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {ListBox} from "primereact/listbox";
import WorkspaceInvitation from "../../models/workspace-invitation/workspace-invitation";
import WorkspaceMembership from "../../models/workspace-membership/workspace-membership";
import {setWorkspaceMembership, setWorkspaceMemberships} from "../../system/app-slice";
import api from "../../system/api";
import UserEventLog from "../../models/user-event-log/user-event-log";
import Icon from "../../system/components/icon";

function AcceptDenyNotificationDialog({visible, setVisible}) {
    const translate = useTranslate();
    const {config, notifications} = useSelector((state) => state.app);
    const [currentItem, setCurrentItem] = useState();
    const [dialogNotifications, setDialogNotifications] = useState();

    useEffect(() => {
        const _dialogNotifications = notifications?.filter(e=>e.displayType==="accept-deny-dialog").map(e=>({label:translate(e.title), value:e.id, data:e}))
        setDialogNotifications(_dialogNotifications)
        setCurrentItem(_dialogNotifications.length>0&&_dialogNotifications[0]);
    }, [notifications]);

    return (
        <Dialog  className={`h-30rem w-11 lg:w-4 ${config.dir}`} header={translate("notifications")} onHide={()=>{setVisible(false)}} visible={visible}>
            <div className="flex h-full border-1 border-300 border-round">
                {/*<ListBox value={currentItem} onChange={(e)=>{setCurrentItem(e.value)}} className="w-3 h-full border-none border-left-1 border-noround-left" options={dialogNotifications}/>*/}
                <ItemContent currentItem={currentItem} setVisible={setVisible}/>
            </div>

        </Dialog>
    );
}

function ItemContent({currentItem, setVisible}) {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const {user} = useSelector(state => state.auth);
    const acceptWorkspaceInvite=async (_invitationData)=>{
        try {
            // const workspaceInvitation = new WorkspaceInvitation();
            // await workspaceInvitation.update(_invitationData.documentId, {invitationStatus:"accepted"});
            await api.post(`/accept-workspace-invitation`, {invitationId:_invitationData.id});

            const workspaceMembership = new WorkspaceMembership();
            const query = {
                filters: {
                    $and:[
                        {member:{$eq: user.id}},
                        // {members: {id:{$eq: user.id}}}
                    ],
                },
                populate:"*"
            }
            const _data = await workspaceMembership.getAll(query);
            dispatch(setWorkspaceMemberships(_data?.data));
            dispatch(setWorkspaceMembership((_data?.data.find(e=>e.isDefault))));
            setVisible(false)
        }catch (e){

        }
    }

    const markUserEventLogAsRead = async (documentId)=>{

        try {
            const userEventLog = new UserEventLog();
            await userEventLog.update(documentId, {isRead:true, readAt: Date.now()})
        }catch (e) {
            console.log(e)
        }
    }

    // useEffect(()=>{
    //     console.log(currentItem)
    // },[currentItem])

    return(
        <div className="flex flex-column p-2 w-full">
            <span className="font-bold">{currentItem?.label}</span>
            <div className="flex-1 mt-3">
                {translate("you-invited-to-workspace-message").replace("{{INVITER}}", currentItem?.data?.audit_log?.after?.inviter?.fullname).replace("{{WORKSPACE}}", currentItem?.data?.audit_log?.after?.workspace?.name)}
                {/*<p>{currentItem?.data.message}</p>*/}
            </div>
            <div className="flex align-items-start gap-1">
                <Icon icon="mi mi:info" className="text-lg text-400"/>
                <span className="text-400 text-xs">{translate("invite-info")}</span>
            </div>
            <Footer onAccept={()=>{acceptWorkspaceInvite(currentItem?.data?.audit_log?.after); markUserEventLogAsRead(currentItem.data?.documentId)}} onCancel={()=>{setVisible(false); markUserEventLogAsRead(currentItem.data?.documentId)}}/>
        </div>
    )
}

function Footer({onAccept, onCancel}){
    const translate = useTranslate();

    return(<div className="flex justify-content-end w-full gap-2">
        <Button className="p-button-success" label={translate("accept")} onClick={()=>{onAccept()}}/>
        <Button className="p-button-secondary" label={translate("reject")} onClick={()=>{onCancel()}}/>
    </div>)
}

export default AcceptDenyNotificationDialog;